import React from 'react';
import { Section } from '@zurich-base-ui/layout.section';
import styles from './SorryPage.module.scss';

import { ReactComponent as ServerProblemPicture } from 'app/assets/Pictograms/ServerProblem.svg';

export const SorryPageView: React.FC = () => {
  return (
    <Section className={styles.section}>
      <ServerProblemPicture />
      <h3 className="body-lg-m">Server problem</h3>
      <p className="body-sm-r">
        Sorry, the app has encountered an error.
        <br />
        It is either not available or it can&apos;t respond at the moment.
      </p>
    </Section>
  );
};

export default SorryPageView;
